export default "__VITE_ASSET__0f8f4e7b__"